var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._l(_vm.posts, function (post) {
    return [_vm.posts ? [_c('InvestPostItem', {
      key: post.id,
      attrs: {
        "item": post
      }
    })] : _vm._e()];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }